<template>
  <router-link class="renewButton btn btn-primary btn-small" :to="{name: 'accountMembershipRenewal'}" v-if="showRenewButton">
    Renew
  </router-link>
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: 'RenewButton',
  components: {

  },
  computed: {
    ...mapState({
      goldExpiration: state => state.member.goldExpiration,
      memberLevel: state => state.auth.memberLevel,
    }),
    showRenewButton() {
      if (this.goldExpiration == null) {
        return false;
      }
      let expiry = new Date(this.goldExpiration);
      let difference = expiry - new Date();
      if (new Date(difference) <= new Date(30 * 60 * 60 * 24 * 1000) && this.memberLevel == "gold") { // If the user is a gold member and the difference between current and expiry date is less than or equal to 30 days
        return true;
      } 
      return false;
    }
  },
}
</script>

<style lang="scss" scoped>
  .renewButton {
    background-color: $CTgold;
    border-color: $CTgold;
    font-size: 0.9rem;
    &:active, &:hover {
      background-color: darken($CTgold, 10%) !important;
      border-color: darken($CTgold, 10%) !important;
    }
  }
</style>
